import React, { Component } from "react";
import Cookies from "universal-cookie";
import moment from "moment";
import { Buffer } from "buffer";

import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";

import { taxOtodisService } from "../../services/otodisApi/TaxOtodisService";

import { Button, Col, DatePicker, Form, Row, Modal, Typography, Alert, Table } from "antd";

import { SaveOutlined, SearchOutlined, ScanOutlined } from "@ant-design/icons";

import { TaxOutSyncStates } from "./types/TaxOutSyncTypes";

export interface SyncTaxOutProps {}

class TaxOutSync extends Component<SyncTaxOutProps & any, TaxOutSyncStates> {
  private readonly initState!: TaxOutSyncStates;
  private uDealer = JSON.parse(Buffer.from(new Cookies().get("_d"), "base64").toString());
  private token = new Cookies().get("_t");
  private tableColumns = [
    {
      title: "Order",
      dataIndex: "order",
      key: "order",
    },
    {
      title: "Keterangan",
      dataIndex: "keterangan",
      key: "keterangan",
      render: (text: string, record: any) => {
        if (record.status === "failed") {
          return <span style={{ color: "red" }}>{text}</span>;
        }
        return text;
      },
    },
  ];

  constructor(props: (SyncTaxOutProps & any) | any) {
    super(props);

    const finalDealerCode = props.match.params.dealerCode.replace(/-/g, "#");

    this.initState = {
      submitting: false,
      loading: false,

      dealerCode: finalDealerCode,

      total_unscanned: -1,
      total_retur: -1,
      total_canceled: -1,
      total_unfinshed: -1,
      total_failed: -1,
      total_success: -1,

      button_scan_disable: true,
      button_sync_disable: true,

      data_table_response: [],

      orderDate: moment().format("YYYY-MM"),
      linkInvoice: "",
      user: "",
    };
    this.state = { ...this.initState };
  }

  async componentDidMount() {
    const cookies = new Cookies();
    const token = cookies.get("_t");
    if (token) {
      const user = JSON.parse(Buffer.from(cookies.get("_u"), "base64").toString());
      await this.promisedSetState({
        user: user,
      });
    }
  }

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      dealerCode: data.value,
    });
  };

  onFieldChange = <T extends keyof Pick<any, "orderDate" | "linkInvoice">>(target: T, value: any) => {
    const currentState: any = { ...this.state };

    switch (target) {
      case "orderDate":
        currentState.orderDate = value;
        break;
      case "linkInvoice":
        currentState.linkInvoice = value;
        break;
    }
    this.setState({
      ...currentState,
    });
  };

  onCheckUnscannedInvoice = async () => {
    this.setState({ submitting: true });

    try {
      taxOtodisService.setToken(this.token);
      await taxOtodisService.checkUnscannedInvoice().then(async (result) => {
        const total_unscanned = Number(result.data.total_file);
        const button_scan_disable = total_unscanned === 0 ? true : false;
        const button_sync_disable = total_unscanned > 0 ? true : false;
        this.setState({ submitting: false, total_unscanned: result.data.total_file, button_scan_disable: button_scan_disable, button_sync_disable: button_sync_disable });
      });
    } catch (e: any) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda : " + e,
      });
      await this.promisedSetState({
        submitting: false,
      });
    }
  };

  onScanInvoice = async () => {
    this.setState({ submitting: true });

    try {
      taxOtodisService.setToken(this.token);
      await taxOtodisService.scanInvoice().then(async (result) => {
        let total_unscanned = this.state.total_unscanned;
        total_unscanned = total_unscanned - result.data.total_scanned;
        const button_scan_disable = total_unscanned === 0 ? true : false;
        const button_sync_disable = total_unscanned > 0 ? true : false;

        this.setState({ submitting: false, total_unscanned: result.data.total_file, button_scan_disable: button_scan_disable, button_sync_disable: button_sync_disable });
      });
    } catch (e: any) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda : " + e,
      });
      await this.promisedSetState({
        submitting: false,
      });
    }
  };

  onSyncData = async () => {
    const currentState: any = { ...this.state };

    if (!currentState.dealerCode) {
      Modal.error({ title: "Error", content: "Invalid Dealer" });
      return;
    }
    if (!currentState.orderDate) {
      Modal.error({ title: "Error", content: "Invalid Order Date" });
      return;
    }
    this.setState({ submitting: true });

    const data_post = {
      dealer_code: currentState.dealerCode,
      date: currentState.orderDate,
      updated_by: currentState.user,
    };

    try {
      taxOtodisService.setToken(this.token);
      await taxOtodisService.syncTaxOut(data_post).then(async (result) => {
        const { total_retur, total_canceled, total_unfinshed, total_failed, total_success, data_failed, data_success } = result.data;
        const dataResponseTable: { order: string; keterangan: string; status: string }[] = [];

        // Pemrosesan data_failed
        Object.entries(data_failed).forEach(([order, errorMessages]: [string, any]) => {
          errorMessages.forEach((errorMessage: string) => {
            dataResponseTable.push({ order: order, keterangan: errorMessage, status: "failed" });
          });
        });

        // Pemrosesan data_success
        data_success.forEach((order: string) => {
          dataResponseTable.push({ order: order, keterangan: "Success", status: "success" });
        });

        this.setState({
          submitting: false,
          total_retur: total_retur,
          total_canceled: total_canceled,
          total_unfinshed: total_unfinshed,
          total_failed: total_failed,
          total_success: total_success,
          data_table_response: dataResponseTable,
        });

        Modal.success({
          title: "Proses Sukses",
          content: "Lihat Table untuk Detail Proses data",
        });
      });
    } catch (e: any) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda : " + e,
      });
      await this.promisedSetState({
        submitting: false,
      });
    }
  };

  onTransferTaxData = async () => {
    const currentState: any = { ...this.state };

    if (!currentState.dealerCode) {
      Modal.error({ title: "Error", content: "Invalid Dealer" });
      return;
    }
    if (!currentState.orderDate) {
      Modal.error({ title: "Error", content: "Invalid Order Date" });
      return;
    }
    this.setState({ submitting: true });

    const data_post = {
      dealer_code: currentState.dealerCode,
      date: currentState.orderDate,
      updated_by: currentState.user,
    };

    try {
      taxOtodisService.setToken(this.token);
      await taxOtodisService.transferMultipleTaxOut(data_post).then(async (result) => {
        const { total_retur, total_canceled, total_unfinshed, total_failed, total_success, data_failed, data_success } = result.data;
        const dataResponseTable: { order: string; keterangan: string; status: string }[] = [];

        // Pemrosesan data_failed
        Object.entries(data_failed).forEach(([order, errorMessages]: [string, any]) => {
          errorMessages.forEach((errorMessage: string) => {
            dataResponseTable.push({ order: order, keterangan: errorMessage, status: "failed" });
          });
        });

        // Pemrosesan data_success
        data_success.forEach((order: string) => {
          dataResponseTable.push({ order: order, keterangan: "Success", status: "success" });
        });

        this.setState({
          submitting: false,
          total_retur: total_retur,
          total_canceled: total_canceled,
          total_unfinshed: total_unfinshed,
          total_failed: total_failed,
          total_success: total_success,
          data_table_response: dataResponseTable,
        });

        Modal.success({
          title: "Proses Sukses",
          content: "Success Sync Data",
        });
      });
    } catch (e: any) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda : " + e,
      });
      await this.promisedSetState({
        submitting: false,
      });
    }
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout onChangeDealer={this.onDealerChange} breadcrumbPath={`Tax Out`} breadcrumbMenu={`Sync Data`} defaultSelectedKeys={["m-tax-out-sync-data"]} defaultOpenKeys={["sm-tax-out"]}>
          <Form layout={"vertical"}>
            <Row>
              <Col xl={{ span: 18 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                <Row>
                  <Col>
                    <Form.Item className={"padTop-10"} label="">
                      <i className={`small-text-grey`}>Tanggal Order</i>
                      <br />
                      <DatePicker defaultValue={moment(this.state.orderDate, "YYYY-MM")} onChange={(event) => this.onFieldChange("orderDate", event)} format={"YYYY-MM"} picker="month" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Button type={"primary"} icon={<SearchOutlined />} loading={this.state.submitting} onClick={this.onCheckUnscannedInvoice} danger style={{ margin: 2 }}>
                    Check Unscanned Files
                  </Button>

                  <Button type={"primary"} icon={<ScanOutlined />} loading={this.state.submitting} onClick={this.onScanInvoice} danger disabled={this.state.button_scan_disable} style={{ margin: 2 }}>
                    Scan File Faktur
                  </Button>

                  <Button type={"primary"} icon={<SaveOutlined />} loading={this.state.submitting} onClick={this.onSyncData} disabled={this.state.button_sync_disable} style={{ margin: 2 }}>
                    Sync Data Pajak
                  </Button>

                  <Button type={"primary"} icon={<SaveOutlined />} loading={this.state.submitting} onClick={this.onTransferTaxData} disabled={this.state.button_sync_disable} style={{ margin: 2 }}>
                    Transfer Data Pajak
                  </Button>
                </Row>
                <Row>
                  <Col>
                    <span>Total&nbsp;Unscanned</span> <span>:</span> <span>&nbsp;</span>
                    <span>{this.state.total_unscanned}</span> <span>&nbsp;</span>
                    <span>Total&nbsp;Retur</span> <span>:</span> <span>&nbsp;</span>
                    <span>{this.state.total_retur}</span> <span>&nbsp;</span>
                    <span>Total&nbsp;Canceled</span> <span>:</span> <span>&nbsp;</span>
                    <span>{this.state.total_canceled}</span> <span>&nbsp;</span>
                    <span>Total&nbsp;Unfinshed</span> <span>:</span> <span>&nbsp;</span>
                    <span>{this.state.total_unfinshed}</span> <span>&nbsp;</span>
                    <span>Total&nbsp;Failed</span> <span>:</span> <span>&nbsp;</span>
                    <span>{this.state.total_failed}</span> <span>&nbsp;</span>
                    <span>Total&nbsp;Success</span> <span>:</span> <span>&nbsp;</span>
                    <span>{this.state.total_success}</span> <span>&nbsp;</span>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 5 }}>
                    <Table dataSource={this.state.data_table_response} columns={this.tableColumns} pagination={false} bordered className="table-mycustom" />
                  </Col>
                </Row>
              </Col>
              <Col xl={{ span: 6 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                <Alert
                  message={
                    <Typography.Paragraph>
                      <b>Tips:</b>
                      <br />
                      <ol>
                        <li>Scan Semua File Faktur sampai Total Unscanned Faktur = 0</li>
                        <li>Ulangi menekan Button Check File Faktur & Scan File Faktur sampai Total Unscanned Faktur = 0</li>
                        <li>Sinkronisasi Data Pajak</li>
                        <li>Lihat pada table data order mana saja yang berhasil dan mana saja yang gagal</li>
                        <li>Lihat keterangan kenapa data gagal di sinkronisasi, ikuti arahan pesan error</li>
                        <li>Ulangi sinkronisasi jika diperlukan (jika terdapat error Failed get XML Faktur, Mohon Ulangi Sinkronisasi)</li>
                        <li>
                          Jika ada error No Link Faktur:
                          <ul>
                            <li>Jika hanya sedikit: gunakan menu Transfer Single Data</li>
                            <li>Jika banyak: lakukan ulang proses upload file faktur, scan, dan sync data pajak. Jika masih gagal, gunakan menu Transfer Single Data</li>
                          </ul>
                        </li>
                      </ol>
                    </Typography.Paragraph>
                  }
                  type="info"
                />
              </Col>
            </Row>
          </Form>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(TaxOutSync), 37);
